exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SkeletonHeadingControls_button-wrapper_2ia5 {\n  display: grid;\n  align-self: center;\n  grid-template-columns: 1fr;\n\n  white-space: nowrap;\n  grid-gap: 10px;\n}\n\n@media screen and (min-width: 768px) {\n\n  .SkeletonHeadingControls_button-wrapper_2ia5 {\n    grid-template-columns: 1fr 1fr;\n    grid-gap: 20px;\n  }\n}\n\n.SkeletonHeadingControls_button_1sI0 {\n  height: 44px;\n\n  border-radius: 8px;\n}\n", ""]);

// exports
exports.locals = {
	"button-wrapper": "SkeletonHeadingControls_button-wrapper_2ia5",
	"button": "SkeletonHeadingControls_button_1sI0"
};